import SkapaSearch, { type SearchProps } from "@ingka/search";

export type SearchFieldProps = SearchProps;

export const SearchField = (props: SearchFieldProps) => {
  return <SkapaSearch prefix="saleslead__" {...props} autoComplete="off" />;
};
